import { render, staticRenderFns } from "./TemporaryAccess.vue?vue&type=template&id=429a405b&scoped=true"
import script from "./TemporaryAccess.vue?vue&type=script&lang=js"
export * from "./TemporaryAccess.vue?vue&type=script&lang=js"
import style0 from "./TemporaryAccess.vue?vue&type=style&index=0&id=429a405b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429a405b",
  null
  
)

export default component.exports